/**
 * Copy of the AMS action kit: the Review AMS Data modals AMS View reuses, and
 * AdGroupList. Wired into `en.ts` as `amsActions`. VentaHub's English,
 * verbatim, from `pages/review_ams_data/components/actions/*` and
 * `components/AdGroupList.tsx` (cited per block).
 */
export const amsActions = {
  // RowActions.tsx:117-195
  rowActions: {
    changeBid: 'Change bid',
    changeBidFor: 'Change bid for {{term}}',
    pauseTarget: 'Pause target',
    pauseTargetFor: 'Pause target {{term}}',
    addNegative: 'Add negative',
    addNegativeFor: 'Add negative {{term}}',
    addTarget: 'Add target',
    addTargetFor: 'Add target {{term}}',
    viewHistory: 'View History',
    viewHistoryFor: 'View History of {{term}}',
    // RowActions.tsx:80
    noEnabledAdGroups: 'No enabled ad groups carry this target in the current period',
  },
  // Shared by the four modals.
  modal: {
    cancel: 'Cancel',
    // ChangeBidModal.tsx:248-251, PauseTargetModal.tsx:190-195
    current: '· current {{bid}}',
    notAvailable: 'N/A',
    // ChangeBidModal.tsx:213, PauseTargetModal.tsx:157
    noInstances: 'No live target instances found for this row.',
    // ChangeBidModal.tsx:217-220
    allInstancesDisabled:
      'None of the ad groups carrying this target are ENABLED — re-enable an ad group to act on it.',
    // helpers.ts:87-92
    instanceDisabled: 'Ad group is {{state}} — actions disabled',
    instanceStateUnknown: 'Ad group state unknown — actions disabled',
  },
  // ChangeBidModal.tsx:186-347
  changeBid: {
    title: 'Change bid',
    instance: 'Ad group instance',
    formula: 'Bid formula',
    cpc: 'CPC formula (CPC × 1.1)',
    asp: 'ASP formula (ASP × conversion × ACOS)',
    aspUnavailable: 'Ad group is missing ASP / conversion / ACOS',
    manual: 'Manual',
    bid: 'Bid',
    previewInvalid: 'Enter a valid bid to preview.',
    preview: 'New bid: {{bid}}',
    previewClamped: 'New bid: {{bid}} (clamped to minimum {{min}})',
    submit: 'Apply bid',
    submitting: 'Applying…',
    done: 'Bid updated to {{bid}} for "{{target}}"',
    failed: 'Failed to change bid',
  },
  // PauseTargetModal.tsx:121-211
  pauseTarget: {
    title: 'Pause target',
    instance: 'Ad group instance to pause',
    submit: 'Pause',
    submitting: 'Pausing…',
    done: 'Paused "{{target}}" in {{adGroup}}',
    failed: 'Failed to pause target',
  },
  // AddNegativeModal.tsx:159-246
  addNegative: {
    title: 'Add negative',
    adGroup: 'Ad group',
    matchType: 'Match type',
    noAdGroups: 'No ad groups found for this row.',
    unsupported: "{{type}} ad groups don't support keyword negatives here.",
    submit: 'Add negative',
    submitting: 'Adding…',
    done: 'Added negative "{{term}}" to {{adGroup}}',
    failed: 'Failed to add negative',
  },
  // AddTargetModal.tsx:137-297, helpers.ts:120-197
  addTarget: {
    title: 'Add target',
    origin: 'Origin ad group',
    destination: 'Destination ad group',
    noOrigins: 'No origin ad groups found for this search term.',
    noDestinations: 'No destination ad groups',
    truncated: 'Showing the first {{shown}} of {{total}} ad groups — type to narrow the list',
    brandFailed:
      "Could not load the rest of this brand's ad groups — the sister slots above are still available.",
    matchType: 'Match type',
    bid: 'Bid (CPC formula): {{bid}}',
    submit: 'Add target',
    submitting: 'Adding…',
    done: 'Added "{{term}}" as a target at {{bid}}',
    failed: 'Failed to add target',
    sisterGroup: 'Sister ad groups',
    brandGroup: 'All ad groups in {{brand}}',
    thisBrand: 'this brand',
    noBrand: 'this store (no brand)',
    unsetSlot: 'N/A',
    sisterAlreadyTarget: '{{slot}} · already a target here',
    sisterState: '{{slot}} · Ad group is {{state}}',
    cannotAccept: 'Cannot accept this target',
    alreadyTarget: 'Already a target here',
  },
  // BidDerivation.tsx:49-161
  bidDerivation: {
    heading: 'How this bid is derived',
    asp: 'ASP {{value}}',
    conversionActual: 'Conv. {{value}} (actual)',
    conversionTarget: 'Conv. {{value}} (target)',
    targetAcos: 'Target ACOS {{value}}',
    actualTip: "Measured over the report window. The ad group's target is {{target}}.",
    noMeasurementTip:
      'This target had no clicks or no units in the window, so the ad group’s target rate is used.',
    unusableTip:
      'Measured rate is {{actual}} — not usable as a bid input, so the ad group’s target rate is used.',
  },
  // AdGroupList.tsx:335-464
  adGroupList: {
    failed: 'Could not load the ad groups.',
    empty: 'No ad groups active in the selected period.',
    open: '{{name}} — open in AMS View',
    openWithSkus: '{{name}} — SKUs: {{skus}} — open in AMS View',
    spend: '{{value}} spend',
    units_one: '{{value}} unit',
    units_other: '{{value}} units',
    sales: '{{value}} sales',
    acos: '{{value}} ACOS',
  },
} as const
